import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { compose } from 'recompose';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles/index';
import IconButton from '@material-ui/core/IconButton';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Tooltip from '@material-ui/core/Tooltip';
import red from '@material-ui/core/colors/red';
import orange from '@material-ui/core/colors/orange';
import EditIcon from '@material-ui/icons/Edit';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { Menu, MenuItem } from '@material-ui/core';
import { grey } from '@material-ui/core/colors';
import Typography from '@material-ui/core/Typography';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import MoneyOffIcon from '@material-ui/icons/MoneyOff';
import { ROLE_ADMIN, ROLE_USER } from '../../constants/roles';
import { SITES } from '../../constants/routes';
import { putSite } from '../../store/sites/actions';
import Spinner from '../Layout/Spinner';

const styles = () => (
  {
    row_container_disabled: {
      backgroundColor: orange[300] + ' !important',
      '&:hover': {
        backgroundColor: orange[500] + ' !important',
      },
    },
    row_container_off_line: {
      backgroundColor: red[300] + ' !important',
      '&:hover': {
        backgroundColor: red[500] + ' !important',
      },
    },
    row_container_invisible: {
      backgroundColor: grey[400] + ' !important',
      '&:hover': {
        backgroundColor: grey[500] + ' !important',
      },
    },
    clickableCell: {
      cursor: 'pointer',
      '&:hover': {
        textDecoration: 'underline',
      },
    },
  }
);

export class SiteRow extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      sendingSiteId: '',
      role: ROLE_USER,
    };
  }

  state = {
    anchorEl: null,
  };

  static propTypes = {
    site: PropTypes.object.isRequired,
  };

  static getDerivedStateFromProps(props, state) {
    let newState = null;
    if (props.authUser && props.roles) {
      newState = {
        ...newState,
        role: props.roles[props.authUser.uid],
      };
    }
    if (!props.sending && state.sendingSiteId) {
      newState = {
        ...newState,
        sendingSiteId: null,
      };
    }
    return newState;
  }

  // Handle

  handleSwitchVisible = (event) => {
    this.setState({ sendingSiteId: this.props.site.id });
    this.props.putSite(
      this.props.authUser.ma,
      this.state.role,
      this.props.site.id,
      {
        state: 0,
      },
    );
    this.setState({ anchorEl: null });
    event.preventDefault();
  };

  handleSwitchUnavailable = (event) => {
    this.setState({ sendingSiteId: this.props.site.id });
    this.props.putSite(
      this.props.authUser.ma,
      this.state.role,
      this.props.site.id,
      {
        state: 1,
      },
    );
    this.setState({ anchorEl: null });
    event.preventDefault();
  };

  handleSwitchInvisible = (event) => {
    this.setState({ sendingSiteId: this.props.site.id });
    this.props.putSite(
      this.props.authUser.ma,
      this.state.role,
      this.props.site.id,
      {
        state: 2,
      },
    );
    this.setState({ anchorEl: null });
    event.preventDefault();
  };

  handleSwitchTraceDirect = (event) => {
    this.props.putSite(
      this.props.authUser.ma,
      this.state.role,
      this.props.site.id,
      {
        is_trace_direct: !this.props.site.is_trace_direct,
      },
    );
    event.preventDefault();
  };

  handleSwitchBookable = (event) => {
    this.props.putSite(
      this.props.authUser.ma,
      this.state.role,
      this.props.site.id,
      {
        is_bookable: !this.props.site.is_bookable,
      },
    );
    event.preventDefault();
  };

  handleClick = event => {
    if (!this.state.pending) {
      this.setState({ anchorEl: event.currentTarget });
    }
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  // Computation

  rowClassName = () => {

    if (this.props.site.state === 2) {
      return this.props.classes.row_container_invisible;
    }
    if (this.props.site.state === 1) {
      return this.props.classes.row_container_disabled;
    }
    if (
      this.props.site.type !== 0
      && this.props.site.type !== 4
      && Date.now() / 1000 - this.props.site.last_update_status > 5 * 60
    ) {
      return this.props.classes.row_container_off_line;
    }
    return null;
  };

  render() {
    const {
      site,
      classes,
    } = this.props;
    const { anchorEl } = this.state;

    const bikeAvailableCell = (
      this.props.site.type === 0 || this.props.site.type === 4
    )
      ? (
        <TableCell>{site.nb_bike_available}</TableCell>
      )
      : (
        <TableCell>{site.nb_bike_available} / {site.nb_stands}</TableCell>
      );

    let stateLabel;
    if (site.state === 0) {
      stateLabel = 'Visible';
    } else if (site.state === 1) {
      stateLabel = 'Indisponible';
    } else {
      stateLabel = 'Invisible';
    }
    return (
      <TableRow
        className={this.rowClassName(site.state)}
        key={site.id}
        hover
        tabIndex={-1}
      >
        <TableCell>{site.number}</TableCell>
        <TableCell>{site.name}</TableCell>
        {
          this.state.role === ROLE_ADMIN
          && <TableCell>{site.renterName}</TableCell>
        }
        {bikeAvailableCell}
        <TableCell numeric>{site.radius}</TableCell>
        <TableCell>{site.turnover / 100} €</TableCell>
        <TableCell>
          <FormControlLabel
            label=""
            control={
              <Checkbox checked={site.is_trace_direct} onChange={this.handleSwitchTraceDirect} />
            }
          />
        </TableCell>
        <TableCell>
          <FormControlLabel
            label=""
            control={
              <Checkbox checked={site.is_bookable} onChange={this.handleSwitchBookable} />
            }
          />
        </TableCell>
        <TableCell>
          <div>
            {
              this.state.sendingSiteId === site.id
              && <Spinner
                style={{
                  parent: {
                    margin: 0,
                    textAlign: 'left',
                  },
                  child: {
                    height: '10px',
                    width: '10px',
                    margin: '0 0.2em',
                  },
                }}
              />
            }

            {this.state.sendingSiteId !== site.id
              && <Typography
                onClick={this.handleClick}
                className={classes.clickableCell}
              >
                {stateLabel}{' '}<ArrowDropDownIcon style={{ verticalAlign: 'sub' }} />
              </Typography>}
          </div>
        </TableCell>
        <TableCell padding="checkbox" align="center">
          <Tooltip title="Modifier">
            <IconButton
              aria-label="update"
              component={Link}
              to={`${SITES}/${site.id}`}
            >
              <EditIcon />
            </IconButton>
          </Tooltip>
        </TableCell>
        {site.is_free_booking
          ? <TableCell align="center">
            <Tooltip title="Site gratuit">
              <MoneyOffIcon />
            </Tooltip>
          </TableCell>
          : <TableCell />
        }
        <Menu
          id="state-menu"
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={this.handleClose}
        >
          <MenuItem onClick={this.handleSwitchVisible} disabled={site.state === 0}>
            Visible
          </MenuItem>
          <MenuItem onClick={this.handleSwitchUnavailable} disabled={site.state === 1}>
            Indisponible
          </MenuItem>
          <MenuItem onClick={this.handleSwitchInvisible} disabled={site.state === 2}>
            Invisible
          </MenuItem>
        </Menu>
      </TableRow>
    );
  }
}

function mapStateToProps(state) {
  return {
    authUser: state.users.authUser,
    roles: state.roles.content,
    sending: state.sites.sending,
  };
}

export default compose(
  withStyles(styles),
  connect(mapStateToProps, { putSite }),
)(SiteRow);



// WEBPACK FOOTER //
// ./src/components/Site/SiteRow.jsx